import regex from '@/constants/regex';

class Validator {
  constructor() {
    // 保存策略对象
    this.strategies = {
      // 验证为空
      isEmpty(value, errorMsg) {
        if (value === null || value === undefined || value === '') {
          return errorMsg;
        }
      },
      // 验证最小长度
      minLength(value, len, errorMsg) {
        if (value.length < len) {
          return errorMsg;
        }
      },
      // 验证最小值
      minValue(value, min, errorMsg) {
        if (value < min) {
          return errorMsg;
        }
      },
      // 验证密码格式
      isPassword(value, errorMsg) {
        if (!regex.password.test(value)) {
          return errorMsg;
        }
      },
      // 验证用户名
      isUsername(value, errorMsg) {
        if (!regex.username.test(value)) {
          return errorMsg;
        }
      },
      // 验证企业用户名
      isCompanyName(value, errorMsg) {
        if (!regex.companyName.test(value)) {
          return errorMsg;
        }
      },
      // 验证简历姓名
      isResumeName(value, errorMsg) {
        if (!regex.resumeName.test(value)) {
          return errorMsg;
        }
      },
      // 验证职位名称
      isJobName(value, errorMsg) {
        if (!regex.jobName.test(value)) {
          return errorMsg;
        }
      },
      // 验证手机号或座机电话
      isPhone(value, errorMsg) {
        if (!regex.phone.test(value)) {
          return errorMsg;
        }
      },
      // 验证邮箱号
      isEmail(value, errorMsg) {
        if (!regex.email.test(value)) {
          return errorMsg;
        }
      },
      // 验证QQ号
      isQQ(value, errorMsg) {
        if (!regex.qq.test(value)) {
          return errorMsg;
        }
      },
      // 验证姓名
      isName(value, errorMsg) {
        if (!regex.name.test(value)) {
          return errorMsg;
        }
      },
      // 验证身份证号
      isIDCard(value, errorMsg) {
        if (!regex.idcard.test(value)) {
          return errorMsg;
        }
      },
    };
    // 验证缓存
    this.validationFns = [];
  }

  // add 方法
  add(inputValue, rule) {
    const self = this;
    for (let i = 0; i < rule.length; i++) {
      // 这里使用闭包储存i 动态添加方法
      (function (i) {
        self.validationFns.push(function () {
          /*
           * aryNames 规则名字(包含传的参数 minLength:6) 所以需要动态的解析
           * errorMsg 错误信息
           * ruleName 方法名字
           * dataArr 储存参数 value method名字 错误信息
           * strategies 使用apply 向指定方法传参数
           */
          const aryNames = rule[i].strategy.split(':');
          const errorMsg = rule[i].errorMsg;
          const ruleName = aryNames[0];
          let dataArr = [];
          dataArr.push(inputValue);
          if (aryNames[1]) {
            dataArr.push(aryNames[1]);
          }
          dataArr.push(errorMsg);
          return self.strategies[ruleName].apply(inputValue, dataArr);
        });
      })(i);
    }
  }

  // 开始验证
  start() {
    // 遍历规则集合 抛出错误
    for (let i in this.validationFns) {
      var msg = this.validationFns[i]();
      if (msg) {
        return msg;
      }
    }
  }
}

export default Validator;
